import React, { useState, useEffect } from 'react';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import useEffectAsync from '../../../../utilities/hooks/useEffectAsync';
import { buildUrlAndOpenWindow, buildUrlAndOpenSameWindow, prepareUrl } from '../../../../utilities/StringHelpers/StringHelpers';
import EpiContext from '@episerver/spa-core/Spa';
import { connect } from 'react-redux';
import Config from '../../../../Config';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import { goToPage, resetBlock, reportDWH, setSelectedEsimLine } from '../saleJetBlockSlice';
import { goToEsimQrCodePageAsync } from '../saleBlockAsyncThunk';
import { setMagicLinkParameters } from '../../../../utilities/authentication/authenticationSlice';
import OrderSuccess from '../Partials/OrderSuccess/OrderSuccess';
import InternetOrderSuccess from '../Partials/InternetOrderSuccess/InternetOrderSuccess';
import OrderSuccsessCellular from '../Partials/Cellular/OrderSuccsess/OrderSuccsess';
import OrderErrorPopUp from '../Partials/Cellular/OrderErrorPopUp/OrderErrorPopUp';
import { gtag4, switchExtraction } from '../../../../utilities/analytics/tracking';
import { getEsimTypeCode, isEsimType, isSimType } from '../../../../utilities/domain/simTypeConstants';
import PurpleInfo from '../../../Shared/PurpleInfo/PurpleInfo';
import { isMobile } from 'react-device-detect';
import Image from '../../../Shared/Image/image';
const SuccessPage = (props) => {
    const [showOrderErrorPopUp, setShowOrderErrorPopUp] = useState(props.saleType == "cellular" ? props.ordersDetailsResults?.hasFailureOrder : false);
    const [termsOfServiceCheckbox, setTermsOfServiceCheckbox] = useState({ isChecked: false, onClickCheckbox: OnClickTermsOfServiceCheckbox, termsLink: props.esimData?.termsOfServiceUrl?.value });
    const [errorText, setErrorText] = useState('');
    //page params
    let isDisplayFooter = true;
    let title = 'ההזמנה בוצעה בהצלחה!';
    let btnText = 'חזרה לעמוד הראשי';
    let cellularPopUpBtnText = '';
    let cellularSubTitle = '';
    let displayCellularEsimIcon = false;
    let totalPrice = null;
    let priceText = '';
    let formid = 'saleJet';
    let isWhiteButton = false;
    //let currentPageFunction = props.saleType == "cellular" ? ActivateEsim : BackToHomePage;
    const isFiberSale = props.saleType == 'internet';
    const isDisplaySaveToCalendar = props.saleType != 'cellular' && !isFiberSale && (props.supplyType == 'technician' || props.supplyType == 'delivery');
    const isDisplaySaveAsPictureBtn = props.saleType == 'cellular' || isFiberSale ? false : true;
    const cellularStep = props.flowType == 'existsCustomer' ? '15' : '14';
    const hasCellularEsimOrder = props.saleType == "cellular" ? props.ordersDetailsResults.hasESim : false;
    const isHboMaxSale = props.additionalResultValues?.isHboMax === 'true';
    const isDisneySale = props.additionalResultValues?.isDisney === 'true';
    if (props.saleType == 'cellular') {
        settingCellularText();
    }
    if (isFiberSale) {
        title = 'תענוג, הסיבים בדרך!';
        btnText = 'סיום';
        isWhiteButton = true;
    }
    //page params

    useEffect(() => {
        if (props.saleType == 'cellular') {
            props.reportDWH({ actionType: 'Create Cellular Order', status: 'Completed', messageText: 'Success' });
        }
        let deliveryPrice = 0;

        props.saleCatalog?.supplyMethods?.map(function (item) {
            if (item.name == 'Delivery' && getPrice(item.price) > 0) {
                deliveryPrice = deliveryPrice + item.price;
            }
        });

        let shippingTier = deliveryPrice > 0 ? 'home delivery' : '';

        gtag4({
            event: props.saleType == 'cellular' ? `cellular_Step${cellularStep}_SucsessPage` : `${props.saleType}_Step10_SuccessPage`,
            step: props.saleType == 'cellular' ? cellularStep : '10',
            package: switchExtraction(props._selectedPackage?.title),
            action: 'SuccessPage',
            funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
        });
        return () => { };
    }, []);

    function OnClickTermsOfServiceCheckbox(isChecked) {
        setTermsOfServiceCheckbox(prevState => ({
            ...prevState,
            isChecked: isChecked
        }));
        setErrorText('');
    }

    function getPrice(price) {
        return price ? price : 0;
    }

    function settingCellularText() {
        if (props.ordersDetailsResults.hasESimWithNewLine) {
            btnText = props.isCellcomAppActive ? 'להפעלת ה-eSIM דרך האפליקציה' : 'להפעלת ה-eSIM';
            isWhiteButton = false;
            cellularPopUpBtnText = 'להפעלת ה-eSIM לקווים שנרכשו';
            title = 'מעולה, יש לך eSIM חדש!';
            cellularSubTitle = props.esimData?.congratsEsimSaleOnlySubTitle.value;
            displayCellularEsimIcon = true;
            if (props.ordersDetailsResults.hasSim) {
                title = (
                    <span>
                        מעולה, יש לך eSIM חדש!
                        <br /> וגם ה-SIM בדרך אליך!
                    </span>
                );
            }
            if (props.ordersDetailsResults.hasESimWithTransferLine) {
                cellularSubTitle = props.esimData?.congratsEsimSaleAndNiudSubTitle.value;
            }
        } else if (props.ordersDetailsResults.hasESimWithTransferLine) {
            btnText = 'קיבלתי את ה-SMS, בואו ננייד';
            isWhiteButton = true;
            cellularPopUpBtnText = 'קיבלתי את ה-SMS, בואו ננייד';
            title = 'עוד קצת ויש לך eSIM';
            cellularSubTitle = props.esimData?.congratsEsimSaleAndNiudSubTitle.value;
            displayCellularEsimIcon = true;
            if (props.ordersDetailsResults.hasSim) {
                title = (
                    <span>
                        עוד קצת ויש לך eSIM
                        <br /> וגם ה-SIM בדרך אליך!
                    </span>
                );
            }
        } else {
            btnText = 'חזרה לעמוד הבית';
            isWhiteButton = true;
            cellularPopUpBtnText = 'למידע על הקווים הנוספים והפעלתם';
            title = 'SIM חדש בדרך אליך!';
            cellularSubTitle = '';
        }
    }

    const fiberSupplyTimeDisplay =
        props.summaryDetails.supplyType == 'technician'
            ? props.summaryDetails.selectedTechnicianTimeDisplay
            : props.summaryDetails.selectedDeliveryTimeDisplay;

    let currentPageHeadline = isFiberSale ? (
        <div className='page-headline-wrapper'>
            <Image
                src={require('../images/internet-order-success.svg')}
                className='internet-success-page__illustration'
                alt=''
            />
            <h1 className='sale-title-big'>{title}</h1>
            {fiberSupplyTimeDisplay && <h2 className='sale-title-small'>קבענו ליום {fiberSupplyTimeDisplay}</h2>}
        </div>
    ) : (
        <div className='page-headline-wrapper'>
            <h1 className='sale-title'></h1>
            {displayCellularEsimIcon && <Image src={require('../images/esim-icon3.svg')} style={{ margin: '20px 0' }} />}
            <h1 className='sale-title-big'>{title}</h1>

            {props.saleType == 'cellular' && cellularSubTitle && <h2 className='sale-title-small'>{cellularSubTitle}</h2>}

            {props.summaryDetails.supplyType == 'technician' && (
                <h2 className='sale-title-small'> נתראה ביום {props.summaryDetails.selectedTechnicianTimeDisplay} </h2>
            )}
            {props.summaryDetails.supplyType == 'delivery' && (
                <h2 className='sale-title-small'> נתראה ביום {props.summaryDetails.selectedDeliveryTimeDisplay} </h2>
            )}

            {isHboMaxSale && (
                <PurpleInfo
                    text={
                        props.summaryDetails.supplyType == 'technician'
                            ? 'לאחר השלמת ההתקנה ע"י טכנאי, יישלח אליך סמס ליצירת חשבון ב-HBO Max כדי להתחיל לצפות בתכנים'
                            : props.summaryDetails.supplyType == 'delivery'
                                ? 'לאחר קבלת הממירים, יישלח אליך סמס ליצירת חשבון ב-HBO Max כדי להתחיל לצפות בתכנים'
                                : (
                                    <>
                                        כדי לצפות בתכני HBO Max, יש ליצור חשבון ב-HBO Max, לינק יישלח אליך בסמס {isMobile && <br />}
                                        בדקות הקרובות
                                    </>
                                )
                    }
                />
            )}
            {isDisneySale && (
                <PurpleInfo
                    text={
                        props.summaryDetails.supplyType == 'technician'
                            ? 'לאחר השלמת ההתקנה ע"י טכנאי, יישלח אליך סמס ליצירת חשבון בדיסני+ כדי להתחיל לצפות בתכנים'
                            : props.summaryDetails.supplyType == 'delivery'
                                ? 'לאחר קבלת הממירים, יישלח אליך סמס ליצירת חשבון בדיסני+ כדי להתחיל לצפות בתכנים'
                                : (
                                    <>
                                        כדי לצפות בתכני דיסני+, יש ליצור חשבון בדיסני+, לינק יישלח אליך בסמס {isMobile && <br />}
                                        בדקות הקרובות
                                    </>
                                )
                    }
                />
            )}
        </div>
    );

    const BackToHomePage = () => {
        props.resetBlock();
        window.location.href = Config.staticWebSiteUrl;
    };

    const ActivateEsim = (urlType) => {
        if (hasCellularEsimOrder && termsOfServiceCheckbox.termsLink) {
            if (!termsOfServiceCheckbox.isChecked) {
                setErrorText('כדי להמשיך יש לאשר את תנאי השירות');
                return;
            }
        }
        const esimLines = props.cellularSettingsList.filter((x) => isEsimType(x.simType));
        if (esimLines?.length > 1) {
            props.goToPage('cellularChooseLineToActivatePage');
        } else if (props.ordersDetailsResults.hasESimWithTransferLine || props.ordersDetailsResults.hasESimWithNewLine) {
            props.reportDWH({ actionType: 'Create Cellular Order', status: 'Completed', messageText: 'eSim Activate Clicked' });
            gtag4({
                event: props.ordersDetailsResults.hasESimWithTransferLine
                    ? `cellular_Step${cellularStep}_NiudButton`
                    : `cellular_Step${cellularStep}_ActivateEsimButton`,
                step: cellularStep,
                button: btnText,
                package: switchExtraction(props._selectedPackage?.title),
                action: props.ordersDetailsResults.hasESimWithTransferLine ? 'NiudButton' : 'ActivateEsimButton',
                funnel_name: `${props.saleType}_Exists${props.flowType == 'existsCustomer' ? '_Exists' : '_New'}_Customer`,
            });
            if (props.ordersDetailsResults.hasESimWithTransferLine) {
                buildUrlAndOpenWindow(props.urlNiudEsimPage);
            }
            else {
                const esimNewLine = props.cellularSettingsList.find(x => isEsimType(x.simType) && x.phoneType == "new")
                if (urlType === 'tinyApp' || urlType === 'tinyUrl') {
                    let esimOrder = props.resultByOrders.find(x => x.orderType == getEsimTypeCode());
                    if (esimOrder) {
                        let magicLink = esimOrder.magicLinkResponse.find(x => x.cli == esimNewLine.phoneNumber);
                        if (magicLink) {
                            const url =
                                urlType === 'tinyApp'
                                    ? magicLink.tinyAppUrl
                                    : urlType === 'tinyUrl'
                                        ? magicLink.tinyUrl
                                        : props.isCellcomAppActive
                                            ? magicLink.tinyAppUrl
                                            : magicLink.tinyUrl;

                            buildUrlAndOpenWindow(url);
                        }
                    }
                }
                else {
                    props.setSelectedEsimLine(esimNewLine);
                    props.goToEsimQrCodePageAsync({ selectedLine: esimNewLine });
                }
            }
        } else {
            BackToHomePage();
        }
    };

    function closeOrderErrorPopUp() {
        setShowOrderErrorPopUp(false);
    }

    function handleOnClickCellularPopUpkBtn() {
        if (isSimType(props.ordersDetailsResults.simTypeSuccess)) {
            setShowOrderErrorPopUp(false);
        } else {
            ActivateEsim();
        }
    }

    const currentPageView = () => {
        if (props.saleType == 'cellular') {
            return (
                <>
                    <OrderSuccsessCellular
                        resultByOrders={props.resultByOrders}
                        cellularSettingsList={props.cellularSettingsList}
                        esimData={props.esimData}
                    />
                    <OrderErrorPopUp
                        showPopUp={showOrderErrorPopUp}
                        onClickBtn={handleOnClickCellularPopUpkBtn}
                        closePopUp={closeOrderErrorPopUp}
                        phoneNumbers={props.ordersDetailsResults.failurePhoneNumbers}
                        btnText={cellularPopUpBtnText}
                    />
                </>
            );
        } else if (isFiberSale) {
            return <InternetOrderSuccess summaryDetails={props.summaryDetails} />;
        } else {
            return <OrderSuccess summaryDetails={props.summaryDetails} isKosherSubscriber={props.isKosherSubscriber} />;
        }
    };

    return (
        <div className={`slideAnimation${isFiberSale ? ' internet-success-page' : ''}`}>
            {currentPageHeadline}
            <div className='sale-page-content'>
                <form noValidate id='sale' onSubmit={handleSubmit}>
                    {currentPageView()}
                </form>
                <SaleFooter
                    className='cancelFixed'
                    isDisplayFooter={isDisplayFooter}
                    isWhiteButton={isWhiteButton}
                    btnText={btnText}
                    onclick={props.saleType == 'cellular' ? ActivateEsim : BackToHomePage}
                    price={totalPrice}
                    priceText={priceText}
                    formid={formid}
                    isDisplaySaveAsPictureBtn={isDisplaySaveAsPictureBtn}
                    isDisplaySaveToCalendar={isDisplaySaveToCalendar}
                    bottomLinkDisplay={props.isCellcomAppActive}
                    termsOfServiceCheckbox={hasCellularEsimOrder ? termsOfServiceCheckbox : null}
                    errorText={errorText}
                />
                {props.isCellcomAppActive && props.ordersDetailsResults.hasESimWithNewLine && (
                    <div className='ml-app-button'>
                        <a href='#' onClick={() => ActivateEsim('tinyUrl')} rel='noopener noreferrer'>
                            להפעלת דרך QR או קודי הפעלה
                        </a>
                    </div>
                )}
            </div>
        </div>
    );

    function handleSubmit(event) {
        event.preventDefault();
    }
};

const mapStateToProps = (state) => {
    return {
        saleType: state.saleJetBlock.saleType,
        flowType: state.saleJetBlock.flowType,
        offerName: state.saleJetBlock.offerName,
        summaryDetails: state.saleJetBlock.summaryDetails,
        resultByOrders: state.saleJetBlock.resultByOrders,
        isCellcomAppActive: state.saleJetBlock.isCellcomAppActive,
        supplyType: state.saleJetBlock.supplyType,
        isKosherSubscriber: state.saleJetBlock.checkUserResponse.isKosherSubscriber,
        confirmationNumber: state.saleJetBlock.paymentInfo.confirmationNumber,
        totalPrice: state.saleJetBlock.totalPrice,
        saleCatalog: state.saleJetBlock.saleCatalog,
        ordersDetailsResults: state.saleJetBlock.cellular.ordersDetailsResults,
        cellularSettingsList: state.saleJetBlock.cellular.cellularSettingsList,
        urlNiudEsimPage: state.saleJetBlock.saleBlockData.urlNiudEsimPage,
        esimData: state.saleJetBlock.saleBlockData.esimData,
        additionalResultValues: state.saleJetBlock.additionalResultValues,
        //other states
        _selectedPackage: state.SalePackagesBlock.selectedPackage,
    };
};

const mapDispatchToProps = {
    goToPage, resetBlock, reportDWH, setMagicLinkParameters, setSelectedEsimLine, goToEsimQrCodePageAsync
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
